import React from "react";
import { TouchableBox } from "arkh";
import {
  TaskTypeIcon,
  TaskTypeIconOptions,
  TaskTypeIconSize,
} from "../../../../types/TaskTypeIcon";
import {
  TaskResponseCheckOptionTitle,
  TaskResponseNumberOptionTitle,
  TaskResponseTextOptionTitle,
} from "./TaskResponseTypeSelect";

const TaskSelectedResponseTypeButton_ = ({
  onPress,
  type,
}: {
  onPress?: () => void;
  type: TaskTypeIconOptions;
}) => (
  <TouchableBox
    disabled={!onPress}
    onPress={onPress ? onPress : undefined}
    style={{
      alignItems: "center",
    }}
  >
    <TaskTypeIcon type={type} size={TaskTypeIconSize.BIG} />
    {type.__typename === "TaskCheck" ? (
      <TaskResponseCheckOptionTitle />
    ) : type.__typename === "TaskNumber" ? (
      <TaskResponseNumberOptionTitle />
    ) : (
      <TaskResponseTextOptionTitle />
    )}
  </TouchableBox>
);

export const TaskSelectedResponseTypeButton = React.memo(
  TaskSelectedResponseTypeButton_
);
